export default __webpack_public_path__ + "static/media/active-pessoa-juridica.b6f63411.svg";